import React from 'react';
import PropTypes from 'proptypes';

const ApplicationTermsAndConditionsModal = ({ closeModal }) => (
  <div>
    <div className="row">
      <button className="square-icon right" onClick={closeModal}>
        X
      </button>
    </div>
    <div className="row">
      <div className="col-md-12">
        <h2>TERMS AND CONDITIONS</h2>
        <p>
          "<strong>Applicant</strong>" - means a specific person who completed and submitted a GIVE
          Application
        </p>
        <p>
          "<strong>Participant</strong>" - means a specific person accepted to volunteer with GIVE
          and registers for a trip.
        </p>

        <h3>ACCEPTANCE CRITERIA</h3>

        <ol>
          <li>
            GIVE welcomes and accepts Applicants who are open and willing to learn about,
            experience, and show respect towards the local culture in the host country and
            communities where Programs are located.
          </li>

          <li>
            Any persons who are 15-years of age or older may apply. GIVE offers trips for various
            age groups. Participants must meet the minimum age requirement for their trip by the day
            of their departure. GIVE welcomes both students and non-students.
          </li>

          <li>
            Participants who are under the age of 18 must have a parent or guardian's signature on
            the trip registration forms.
          </li>

          <li>
            All Participants must be physically, mentally, and medically capable of participating in
            all projects and activities included in the program. GIVE may require a medical form and
            doctor's release form in some circumstances.
          </li>
        </ol>

        <h3>ACCEPTANCE PROCEDURES</h3>

        <ol>
          <li>
            Each Participant must complete and submit the GIVE Application. This does not commit or
            bind Applicants to GIVE Programs; each Applicant must be accepted before they are
            eligible to participate in GIVE Programs.
          </li>

          <li>
            GIVE will contact each Applicant to inform them of his/her a) acceptance into the
            program b) non-acceptance, or c) pending application due to a need for more information.
          </li>

          <li>
            If accepted, GIVE will notify the Applicant by email and include instructions regarding
            the completion of the GIVE Program Agreement.
          </li>

          <li>
            The GIVE Program Agreement must be completed and submitted through the Applicant's
            Volunteer Profile with a non-refundable deposit for all trip(s) and add-on(s). The
            deposit does not expire; it is good for life. Refer to our cancellation policy below for
            additional details.
          </li>

          <li>
            Participants can select their Program on a first-come, first-served basis in the order
            that their GIVE Program Agreement and deposit(s) are received.
          </li>

          <li>
            If a Participant's trip preferences change from the original departure date, the
            Participant may request to transfer the dates of their GIVE Program. The Participant
            must contact the GIVE office to confirm new Program dates (subject to space
            availability) and GIVE will complete the transfer. Transfer requests are subject to the
            cancellation policies listed below.
          </li>
        </ol>

        <h3>PRIVACY POLICY</h3>
        <p>
          GIVE respects and is committed to protecting your privacy and we appreciate your trust.
          When you sign up, apply, or complete GIVE's registration form, you give us certain
          information (such as name and email address). Upon making a purchase, we collect payment
          information, contact information, and details of what you bought. The information you
          provide is used only by GIVE to respond to your inquiries and contact you about the
          products/services on our site in which you have expressed interest.
        </p>

        <h3>DEPOSITS</h3>

        <p>
          The trip deposit (and add-on deposit(s) if applicable) and GIVE Program Agreement, bearing
          a Participant or guardian's signature, if necessary, must be submitted to participate in a
          GIVE Program. The trip deposit and add-on deposit(s) are non-refundable but good for life.
          Deposit and add-on deposit(s) cannot be transferred to a different individual.
        </p>
        <p>
          These monies permit GIVE to execute and provide: customer support, trip preparations,
          maintain programs annually while GIVE is not operating trips, make necessary reservations
          and arrangements, and confirm the Participant's commitment to participate in the Program.
          GIVE will reserve the Participant's Program placement dates upon receipt of the
          non-refundable deposit(s) and completed Agreement (subject to availability).
        </p>
        <h3>What's Included In Your Trip Cost</h3>
        <p>GIVE'S PROGRAM INCLUDES</p>
        <ul>
          <li>All accommodations during the Participant's specified GIVE Program dates</li>
          <li>
            At least three (3) meals per day on all trips and add-ons, except on arrival and
            departure days, when included meals will be based on flight arrival and departure times
          </li>
          <li>All cultural and adventure activities listed on program itinerary</li>
          <li>National/local park fees</li>
          <li>All Program ground and water transportation in the host country</li>
          <li>All organization and associated fees charged in the host country</li>
          <li>Orientation(s) in host country</li>
          <li>Program management and program arrangements</li>
          <li>Administration and recruitment costs</li>
          <li>Dedicated and trained GIVE and local guides</li>
          <li>GIVE program overview, packing list, and trip preparation information</li>
          <li>All materials, staffing, and requirements to complete the volunteer initiatives</li>
        </ul>

        <h3>GIVE'S PROGRAM COST DOES NOT INCLUDE:</h3>
        <ul>
          <li>
            All air transportation to and within the host country and all other associated air
            taxes, ticket fees, and any country departure taxes
          </li>
          <li>
            All transportation and accommodation costs prior to or subsequent to the Participant's
            program dates
          </li>
          <li>Medical and travel/trip cancellation insurance (required)</li>
          <li>Passports, travel visas (where necessary) and any vaccinations or medications</li>
          <li>
            Any additional, optional activities available for Participants not listed on program
            itinerary
          </li>
          <li>Academic or Internship credit</li>
          <li>Gratuities</li>
        </ul>

        <h3>FINANCIAL DUE DATES</h3>
        <p>
          Any and all payments associated with GIVE Program costs are due to GIVE on or before
          80-days prior to a Participant's departure date. If a participant registers less than
          80-days before the trip, we will mutually agree on new deadlines. All payments must be
          received prior to departure.
        </p>
        <p>
          GIVE will provide Participants with a payment summary and display any balance due via the
          GIVE Profile. Full payment is due 80 days prior to a Participant's departure date and GIVE
          charges a $50.00 fee for late payments. Participants may contact GIVE for payment options,
          if necessary.
        </p>
        <p>
          If GIVE does not receive full payment 80 days prior to departure and no prior
          arrangements, have been made with GIVE, then GIVE will (1) assume the Participant has
          canceled their GIVE Program and (2) charge a $150.00 late cancellation fee. Once canceled,
          Participant's placement for the GIVE Program and/or specific departure date is not
          guaranteed, even if a Participant becomes reinstated until final payment is received.
        </p>

        <p>
          For third-party hosted programs or private trips, the third-party or private trip terms
          and due dates supersede these terms (read more below). GIVE reserves the right to move a
          Participant's Program dates for the GIVE Program within a reasonable amount of time per
          GIVE's discretion
        </p>

        <h3>Trip Deadlines</h3>
        <p>
          GIVE provides support through the trip preparation process and has established document
          and payment deadlines. These deadlines enable you to access advantageous airfare, receive
          full travel insurance coverage benefits, and meet processing timeframes for your travel
          documents.
        </p>
        <p>
          Your trip documents are due by the below deadlines or deadline extensions approved by
          GIVE. If you register for your trip after the below deadlines, GIVE will work with you to
          establish new deadlines. GIVE charges a $50.00 fee for late documents past the below
          deadlines or pre-approved deadlines.
        </p>
        <p>
          <i>See financial commitments and deadlines below.</i>
        </p>

        <h3>DOCUMENT DEADLINE: 90 DAYS PRIOR TO TRIP START</h3>
        <p>
          GIVE requires certain travel documents for your trip, such as Travelers Insurance and
          travel documentation. You can manage and submit your required documents from your
          Volunteer Profile.
        </p>
        <ul>
          <li>All travel documents are due 90 days before your trip start date.</li>
          <li>
            You can still register for a trip within 90 days of your trip start date and we will
            work with you on deadlines. Generally, if you register within 90 days of your trip start
            date, you must submit your required documents within 30 days of trip registration date.
          </li>
          <li>
            All travel documents must be received and reviewed to be eligible to join your trip.
          </li>
        </ul>

        <h3>PAYMENT OPTIONS</h3>
        <p>
          When registering for a GIVE Program, participants may choose from the following payment
          structures:
        </p>
        <ul>
          <li>
            Pay in Full
            <ul>
              <li>
                Participants who pay their full program balance at the time of registration may
                receive a discount off the total program cost.{' '}
              </li>
              <li>
                <b>
                  All payments made under this plan are non-refundable and valid only as lifetime
                  travel credit.
                </b>
              </li>
            </ul>
          </li>
          <li>
            Buy Now, Pay Later (BNPL)
            <ul>
              <li>
                GIVE may offer BNPL options via third-party providers or internal installment plans.
              </li>
              <li>
                <b>
                  Participants who choose BYPL options agree that all payments are non-refundable
                  and valid only as lifetime travel credit.
                </b>
              </li>
            </ul>
          </li>
          <li>
            Recurring Payment Plan
            <ul>
              <li>
                Participants who enroll in GIVE's monthly payment plan may receive a discount off
                the total program cost.{' '}
              </li>
              <li>
                <b>
                  All payments made under this plan are non-refundable and valid only as lifetime
                  travel credit.
                </b>
              </li>
            </ul>
          </li>
          <li>
            Standard Payment Plan
            <ul>
              <li>
                Participants pay a <b>non-refundable deposit</b> to secure their spot, then pay the
                remaining balance by the payment deadline.
              </li>
              <li>
                Remaining balance payments are eligible for <b>partial cash refunds</b>, excluding
                any deposit(s), based on the cancellation timeline below. Participants retain the
                option to convert any remaining funds into lifetime travel credit.
              </li>
            </ul>
          </li>
          <li>
            Payments eligible for a lifetime travel credit are subject to the terms outlined in the
            Travel Credit Policy below.
          </li>
        </ul>

        <h3>Travel Credit Policy</h3>
        <p>
          In cases where a Participant is unable to travel, GIVE may issue a non-refundable travel
          credit in lieu of a refund, at its sole discretion and in accordance with the below Terms.
          Travel credits are:
        </p>
        <ul>
          <li>Valid for life.</li>
          <li>Issued in the name of the original Participant.</li>
          <li>
            Redeemable at a dollar-for-dollar value toward the base cost of any future GIVE program.
          </li>
          <li>
            Non-transferable to another person unless explicitly authorized by GIVE in writing.
          </li>
          <li>Not redeemable for cash or refunds under any circumstances.</li>
          <li>
            Subject to availability, program pricing, and GIVE's offerings at the time of
            redemption.
          </li>
        </ul>
        <p>
          Travel credits do not accrue interest, do not constitute a trust or escrow, and are only
          redeemable for eligible GIVE trips.
        </p>
        <h3>Cancellation Dates & Corresponding Fees (Standard Payment Plan Only)</h3>
        <p>
          All trip cancellations less than 80-days before the trip start date incur a $150 late
          cancellation fee. This $150 late cancellation fee will be deducted from the remaining
          balance of the canceled trip or reinstate the non-refundable deposit(s) towards a future
          trip. The term “deposit(s)” below includes any and all trip deposit(s) and add-on
          deposit(s). Participants will be subject to the following terms based on the cancellation
          timeframe:
        </p>

        <p>If you cancel your trip with…</p>
        <ul>
          <li>
            80 days or more prior to departure: All deposit(s) are non-refundable and
            non-transferable, but good for life!
          </li>
          <li>
            79 to 70 days prior to departure: Loss of 25% of the total program cost, excluding
            non-refundable deposit(s), and a $150 late cancellation fee.
          </li>
          <li>
            69 to 50 days prior to departure: Loss of 50% of total program cost, excluding
            non-refundable deposit(s), and a $150 late cancellation fee.
          </li>
          <li>
            49 to 31 days or less prior to departure: Loss of 75% of total program cost, excluding
            non-refundable deposit, and a $150 late cancellation fee.
          </li>
          <li>
            30 days or less prior to departure: Loss of 100% of total program cost, including
            non-refundable deposit(s).
          </li>
          <li>
            Failure to show up: Loss of 100% of total program cost, including non-refundable
            deposit(s).
          </li>
        </ul>
        <p>
          Please note that the above cancellation policy does not include airfare as travelers are
          subject to the airlines' airfare terms and conditions.
        </p>

        <p>
          Any cancellation eligible for cash refunds will be processed at the end of the GIVE
          scheduled program term per the traveler's request. There will be a $75 administrative fee
          to process refunds. If cancellation reasons are within the terms of a Participant's travel
          Trip Cancellation and Interruption Insurance Policy, then the Participant must inform
          his/her insurance carrier and file a claim for possible reimbursement.
        </p>

        <p>
          <b>Third-Party Hosted Programs:</b> For any program facilitated by GIVE that is hosted by
          a third-party organization, the Deposit, Payment, Refund and Transfer Policy of the third
          party will supersede the terms and conditions outlined in this document. Participants are
          required to review and agree to the third party's policies before completing their
          registration. GIVE is not responsible for the enforcement or interpretation of the third
          party's policies and cannot offer exceptions, refunds, or accommodations outside of what
          is stipulated by the hosting organization. By signing up for a third-party-hosted program,
          participants acknowledge and accept these terms.
        </p>

        <p>
          <b>Third-Party Hosted Programs:</b> For any program facilitated by GIVE that is hosted by
          a third-party organization, the Deposit, Payment, Refund and Transfer Policy of the third
          party will supersede the terms and conditions outlined in this document. Participants are
          required to review and agree to the third party's policies before completing their
          registration. GIVE is not responsible for the enforcement or interpretation of the third
          party's policies and cannot offer exceptions, refunds, or accommodations outside of what
          is stipulated by the hosting organization. By signing up for a third-party-hosted program,
          participants acknowledge and accept these terms.
        </p>
        <p>
          <b>Private Trips:</b> Private trips are governed by the terms and conditions mutually
          agreed upon by GIVE and the designated representative of the private group.
        </p>
        <h3>LEGAL DISPUTE</h3>
        <p>
          In the event that a dispute shall arise between parties to the Program Agreement with
          regard to any of the provisions or the performance of any Terms and Conditions of the
          Agreement, Participant agrees that the exclusive venue for dispute resolution shall be
          King County Superior Court in Seattle, Washington.
        </p>
        <p>
          <b>
            <i>
              See below for the policy and terms regarding trip transfers and/or if GIVE cancels
              your trip.
            </i>
          </b>
        </p>

        <h3>Trip Transfers</h3>
        <p>If you transfer or change your trip dates…</p>
        <ul>
          <li>
            GIVE offers flexible trip transfers and payments convert to a nonrefundable travel
            credit once transferred. All transfers are subject to availability and the cancellation
            timetable listed above. Transfers less than 80 days prior to the trip start date incur a
            $150 transfer fee.
          </li>
          <li>
            Any trip payments not utilized within 2 years of the payment date convert to a
            good-for-life travel credit to be utilized for any available GIVE trip location.
          </li>
        </ul>
        <p>
          <i>See the policy below if GIVE cancels your trip due to Force Majeure</i>
        </p>

        <h3>Cancellation due to Force Majeure</h3>
        <p>If GIVE cancels or POSTPONES your trip…</p>
        <p>
          GIVE will not be responsible for any trip delay, alteration, cancelation, or failure to
          perform its obligations pursuant to these Terms if caused by Force Majeure or forces of
          nature, foreseeable or unforeseeable events, or circumstances beyond its reasonable
          control. Such circumstances include but are not limited to acts of God, lightning strikes,
          earthquakes, floods, storms, explosions, fires, and any natural disaster; pandemics or
          epidemics; acts of war, protests, terrorism, riots, civil commotion, malicious damage,
          sabotage and revolution; and strikes.
        </p>

        <h3>USE OF FUNDS</h3>

        <p>
          Participant payments—including deposits, installments, and final balances—play a vital
          role in helping GIVE operate year-round and deliver meaningful travel experiences. These
          funds support ongoing operations such as staffing, project development, program logistics,
          safety and compliance, and community impact initiatives across all GIVE locations. By
          submitting payment, participants understand and agree that funds may be used in advance of
          their travel date and are subject to GIVE's cancellation, refund, and travel credit
          policies as outlined in these Terms and Conditions.
        </p>

        <h3>PROGRAM ITINERARY</h3>
        <p>
          GIVE reserves the right to modify and/or change the Program itinerary without notice.
          Every reasonable effort will be employed to operate the Program as planned. Should
          unforeseen events and conditions require the itinerary to be altered or cancelled, GIVE
          reserves the right to do so for the safety and best interest of Participants. If these
          issues occur and GIVE is forced to cancel a Program, GIVE will attempt to rebook the
          Participant to an alternate program, subject to conditions and availability, and Force
          Majeure Terms and Conditions will apply.
        </p>

        <h3>LEGAL DISPUTE</h3>
        <p>
          In the event that a dispute shall arise between parties to the Program Agreement with
          regard to any of the provisions or the performance of any Terms and Conditions of the
          Agreement, Participant agrees that the exclusive venue for dispute resolution shall be
          King County Superior Court in Seattle, Washington.
        </p>

        <h3>TRAVELERS INSURANCE</h3>
        <p>
          All Participants are required to secure travelers insurance with trip cancellation, trip
          interruption, and medical coverage for the duration of the GIVE Program. Participants must
          select a policy that meets GIVE's required minimum standards and their individual needs,
          such as pre-existing conditions, coverage limits, travel duration, etc. All Participants
          are responsible for choosing insurance with medical coverage sufficient to cover the
          Participant while abroad for the duration of the GIVE Program.
        </p>
        <p>
          It is important that Participants thoroughly read and review any insurance policy,
          specifically in regard to cancellation trip interruption and medical circumstances. GIVE
          is not responsible for any travel/trip insurance actions, exclusions, or omissions. GIVE
          requires Participants to submit their proof of travel/trip cancellation insurance to the
          GIVE office by the document deadline.
        </p>

        <h3>MEDICAL DISCLOSURE</h3>
        <p>
          GIVE requires all volunteer Participants to advise the GIVE office of any pre-existing or
          current medical condition and/or allergies either on the GIVE medical form or by e-mail.
          GIVE is not responsible for any omissions in regard to the volunteer Participants' medical
          information.
        </p>

        <h3>FLIGHTS</h3>
        <p>
          GIVE strongly recommends all Participants purchase flights through GIVE's dedicated flight
          providers to/from the host country(s) or program. This ensures the Participant meets
          GIVE's arrival and departure requirements and smooth travel with our dedicated partner's
          support. If Participants cannot book through our recommended providers, then they must
          contact GIVE regarding alternate travel plans.
        </p>

        <h3>TRANSPORTATION IN HOST COUNTRY</h3>
        <p>
          Ground and water transportation within the host country is provided by GIVE within the
          confines of the GIVE itinerary; any additional travel requirements or arrangements outside
          of the GIVE itinerary must be paid for by the Participant. Air transportation to/from GIVE
          trips and/or add-ons is not included in the trip cost.
        </p>

        <h3>ORIENTATION (Mandatory)</h3>
        <p>
          GIVE provides orientation meeting(s) in the Participant's host country(s) as well as an
          interactive debriefing seminar before the end of the excursions. The orientation(s) are
          conducted by GIVE Guides in the host country(s) with the purpose of preparing
          Participants. The final debriefing seminar is an interactive meeting meant to gain insight
          from our Participants about our Programs and volunteer initiatives.
        </p>

        <h3>VOLUNTEER PROCEDURES</h3>
        <p>
          GIVE will provide information on Volunteer Initiatives to Participants via email prior to
          their departure date. Information sent to Participants will describe project goals, host
          organization background and facts, accommodations, meals, volunteer tasks, suggested
          reading material, a packing list health and safety considerations, and more.
        </p>
        <p>
          All GIVE groups will be accompanied by a GIVE Guide to collaborate with the host
          organization, facilitate group discussions, supervise volunteer activities and promote the
          Participants' safety. GIVE reserves the right to modify volunteer projects without notice,
          subject to unforeseen conditions.
        </p>

        <h3>MEALS ON THE GIVE PROGRAM</h3>
        <p>
          Participants are encouraged to try local foods to authenticate their experience. During
          the Program, GIVE will provide at least three (3) meals a day, excluding arrival and
          departure days as included meals will be based on flight arrival and departure times.
          Participants must inform GIVE HQ of dietary needs either in their application or via
          email. Vegetarians and vegans can be accommodated. GIVE can accommodate most but not all
          dietary needs; in such certain cases, Participants may need to supplement the included
          meals at their own expense. Participants with food allergies (or other allergies) must
          ensure that GIVE is aware of such allergies and the severity of the allergies.
        </p>
      </div>
    </div>
  </div>
);

ApplicationTermsAndConditionsModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default ApplicationTermsAndConditionsModal;
